import * as React from 'react';
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from "../app/ApplicationContext";
import furoApi from "../api/FuroApi";
import {ErrorResponse} from "../api/dtos/dtos";
import {YearMonth} from "./utils/YearMonthRangePicker";
import {ErrorAlert} from "../common/ErrorAlert";
import {CategoryRangeStatistics, StatisticsRequest, TotalCategoryCostStatistics,} from "../api/dtos/statistics";
import CategoryStatisticsPanel from "./CategoryStatisticsPanel";

interface State {
  categories: string[];
  totalCostStats?: TotalCategoryCostStatistics;
  categoryStats?: CategoryRangeStatistics,
  error?: ErrorResponse;
}

export default class CategoryStatisticsPage extends React.Component<{}, State> {

  public readonly loadingHandler?: LoadingOverlayHandler;

  public state: State = {
    categories: []
  };

  public componentDidMount(): void {
    this.loadCategories();
  }

  public render(): React.ReactNode {
    const {categories, error, totalCostStats, categoryStats} = this.state;
    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        <CategoryStatisticsPanel
          categories={categories}
          onCategoryChange={this.onCategoryChange}
          onQueryParamsChange={this.onQueryParamsChange}
          totalCostStats={totalCostStats}
          categoryStats={categoryStats}
        />

        <ErrorAlert style={{marginTop: 16}} error={error}/>
      </>
    );
  }

  private onCategoryChange = (category: string) => {
    this.loadTotalCategoryCostStatistics(category);
  };

  private onQueryParamsChange = (category: string, start: YearMonth, end: YearMonth) => {
    const request: StatisticsRequest = {
      startYear: start.year,
      startMonth: start.month,
      endYear: end.year,
      endMonth: end.month
    };
    this.loadCategoryStatsInRange(category, request);
  };

  private loadCategories = () => {
    const promise = furoApi.items.getCategories()
      .then(response => this.setState({
        categories: response.categories
      }))
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private loadTotalCategoryCostStatistics = (category: string) => {
    const promise = furoApi.statistics.getTotalCategoryCostStatistics(category)
      .then(response => this.setState({
        totalCostStats: response,
        error: undefined
      }))
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private loadCategoryStatsInRange = (category: string, request: StatisticsRequest) => {
    const promise = furoApi.statistics.getCategoryStatistics(category, request)
      .then(response => this.setState({
        categoryStats: response,
        error: undefined,
      }))
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onApiError = (error: ErrorResponse) => {
    this.setState({error});
  };
}


// WEBPACK FOOTER //
// ./src/statistics/CategoryStatisticsPage.tsx